import { parse } from "date-fns";

export const packages = [
  {
    id: "couple",
    name: "Couple Package",
    price: 1900,
    priceLabel: "\u20B91,900",
    subtitle: "With your own car",
    tag: "Most Popular",
    features: [
      "For 2 people",
      "Drive in with your own car",
      "Premium big screen viewing",
      "Food & snacks on orders",
      "Complimentary welcome drinks",
      "Under the stars experience",
    ],
  },
  {
    id: "group",
    name: "Group Package",
    price: 2100,
    priceLabel: "\u20B92,100",
    subtitle: "With your own car",
    tag: "Best for Friends",
    features: [
      "For up to 4 people",
      "Drive in with your own car",
      "Premium big screen viewing",
      "Food & snacks on orders",
      "Complimentary welcome drinks",
      "Under the stars experience",
    ],
  },
  {
    id: "private",
    name: "Private Space",
    price: 1150,
    priceLabel: "\u20B91,150",
    priceUnit: "/seat",
    subtitle: "Comfortable chair seating",
    tag: "Intimate",
    features: [
      "Private enclosed seating",
      "No car needed",
      "Premium screen viewing",
      "Food on orders",
      "Ideal for intimate setting",
      "Under the stars experience",
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Priyanka",
    location: "Guwahati",
    text: "\u201CAn absolutely magical evening. Watching a movie under the stars beside the waterfall was something we will never forget. The sound of the waterfall made it surreal.\u201D",
    rating: 5,
  },
  {
    id: 2,
    name: "Bibek",
    location: "Guwahati",
    text: "The perfect date night spot. Private, beautiful, and the waterfall sounds made it so peaceful. We are definitely coming back for more.",
    rating: 5,
  },
  {
    id: 3,
    name: "George",
    location: "Shillong",
    text: "\u201CWe brought our own car and drinks. Felt like our own private cinema. The hills, the stars, the movie, everything was perfect. Highly recommended!\u201D",
    rating: 5,
  },
  {
    id: 4,
    name: "Rakesh & Dimpi",
    location: "Guwahati",
    text: "\u201CThe setting is breathtaking. A great experience. Thanks for allowing to bring our booze. Made the evening for us. This is exactly what we needed.\u201D",
    rating: 5,
  },
];

export const faqItems = [
  {
    question: "Where is the location?",
    answer:
      "The location is at Amsing, just 35 minutes from Guwahati, towards Sixmile-Narengi road. It is a scenic setting beside hills and waterfall. Exact location details are shared upon reservation confirmation.",
  },
  {
    question: "Can I bring my own car?",
    answer:
      "Absolutely! The Couple and Group packages are designed for you to enjoy the movie from the comfort of your own car. Just drive in and park at your designated spot.",
  },
  {
    question: "What is the Private Space option?",
    answer:
      "If you don\u2019t have a car, or prefer a more intimate setting, you can book private spaces at \u20B91,150 per seat with a clear view of the screen, in an enclosed space.",
  },
  {
    question: "Can I bring my own food and drinks?",
    answer:
      "We encourage you to bring your own booze (alcohol). You can get hot and delicious food served at your place on instant orders. This is your experience to customise. We also have a welcome drink for you at the venue.",
  },
  {
    question: "Is it safe?",
    answer:
      "Safety is our top priority. The location is private, secured, well-lit where needed, and staffed throughout the evening. Your comfort and security are guaranteed.",
  },
  {
    question: "How do I book?",
    answer:
      "Simply click the \u201CReserve Now\u201D button, fill in your details, choose your preferred slot and package, and we\u2019ll confirm your booking via email and WhatsApp.",
  },
  {
    question: "What if it rains?",
    answer:
      "We monitor weather conditions closely. In case of rain, we\u2019ll reschedule your experience to the next available date at no extra cost.",
  },
  {
    question: "What movies are screened?",
    answer:
      "We curate a mix of popular Bollywood and Hollywood classics that everyone love. Let it be a romantic surprise for you and your partner or friends.",
  },
];

export const features = [
  {
    icon: "Film",
    title: "Open-Air Cinema",
    description:
      "Watch movies on a big screen under the open sky, with your close ones.",
  },
  {
    icon: "Mountain",
    title: "Hills & Waterfall",
    description:
      "Nestled beside natural hills and a cascading waterfall for the perfect backdrop.",
  },
  {
    icon: "Wine",
    title: "BYOB Friendly",
    description:
      "Bring your own booze (alcohol). This is your evening, your way.",
  },
  {
    icon: "Shield",
    title: "Private & Safe",
    description:
      "An enclosed, private pod curated for couples and small groups.",
  },
  {
    icon: "Car",
    title: "Drive-In Ready",
    description:
      "Bring your own car and enjoy the movie from the comfort of your vehicle.",
  },
  {
    icon: "Headphones",
    title: "Food on order",
    description: "Delicious menu served at your space or car on your orders.",
  },
];

export const howItWorks = [
  {
    step: 1,
    icon: "Ticket",
    title: "Choose Your Package",
    description: "Select from our Couple, Group, or Private Space options.",
  },
  {
    step: 2,
    icon: "CalendarDays",
    title: "Pick a Slot",
    description: "Choose your preferred slot for the experience.",
  },
  {
    step: 3,
    icon: "MapPin",
    title: "Arrive & Settle In",
    description: "Drive in or walk to your space. Just 35 min from Guwahati.",
  },
  {
    step: 4,
    icon: "Sparkles",
    title: "Enjoy the Magic",
    description: "Sit back, relax, and let the stars be your ceiling.",
  },
];

export const galleryImages = [
  {
    src: "https://images.unsplash.com/photo-1756729924307-060d48637ccc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxvdXRkb29yJTIwY2luZW1hJTIwbmlnaHR8ZW58MHx8fHwxNzcwMzU4OTc5fDA&ixlib=rb-4.1.0&q=85",
    alt: "Outdoor cinema setup under the stars",
  },
  {
    src: "https://images.unsplash.com/photo-1762279993731-4fcaf448e1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGhpbGxzJTIwd2F0ZXJmYWxsfGVufDB8fHx8MTc3MDM1OTAyMXww&ixlib=rb-4.1.0&q=85",
    alt: "Lush green hills and waterfall",
  },
  {
    src: "https://images.unsplash.com/photo-1769981056347-b69cca4a4236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxvdXRkb29yJTIwZmFpcnklMjBsaWdodHMlMjBldmVuaW5nfGVufDB8fHx8MTc3MDM1OTAyNXww&ixlib=rb-4.1.0&q=85",
    alt: "Romantic fairy lights evening ambiance",
  },
  {
    src: "https://images.unsplash.com/photo-1606247357835-d27fe83fc6a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxzdGFycnklMjBuaWdodHxlbnwwfHx8fDE3NzAzNTg5OTR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Starry night sky over mountains",
  },
];

export const contactInfo = {
  phone: "+91 8638746824",
  email: "support@tcexp.in",
  location: "Amsing, Guwahati, Assam",
};

export const availableSlots = getDynamicSlots();

function getDynamicSlots() {
  const deltaDays = process.env.REACT_APP_DELTA_DAYS || 30;
  const lastDateStr = process.env.REACT_APP_LAST_DATE;

  const skipDates = process.env.REACT_APP_SKIP_DATES
    ? process.env.REACT_APP_SKIP_DATES.split(",")
    : []; // should be in YYYY-MM-DD format, e.g. "2024-12-25,2025-01-01"

  const slotDays = process.env.REACT_APP_SLOT_DAYS
    ? process.env.REACT_APP_SLOT_DAYS.split(",").map((d) => parseInt(d))
    : [];

  const start = new Date();
  let end;
  if (lastDateStr) {
    end = parse(lastDateStr, "yyyy-MM-dd", new Date());
  } else {
    end = new Date();
    end.setDate(end.getDate() + parseInt(deltaDays));
  }

  const slots = [];
  for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
    const day = d.getDay();
    if (slotDays.includes(day)) {
      const dateStr = d.toLocaleDateString("en-CA");
      if (skipDates.includes(dateStr)) continue;
      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        weekday: "long",
      };
      const label = d.toLocaleDateString("en-US", options);
      slots.push({ value: dateStr, label });
    }
  }

  return slots;
}

export const navLinks = [
  { label: "Experience", href: "#about" },
  { label: "Packages", href: "#packages" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];
